import {
  CreditCardOutlined,
  EyeOutlined,
  FileOutlined,
  SkinOutlined,
  WarningFilled,
} from '@ant-design/icons';
import { Status } from '@mm/components';
import { abbreviateNumber } from '@mm/utils';
import { InputNumber } from 'antd';
import classNames from 'classnames';
import React, { memo } from 'react';
import styles from './MetaEventsTableMock.module.css';

type Props = {
  traffic: number;
  pageView: number;
  setPageView: (value: number) => void;
};

const MemoizedInputNumber = memo(
  ({
    value,
    readOnly,
    onChange,
  }: {
    value: number;
    readOnly: boolean;
    onChange: (value: number) => void;
  }) => (
    <InputNumber
      status="warning"
      value={value}
      controls={false}
      readOnly={readOnly}
      className={classNames(styles.inputNumber, {
        [styles.editableInput]: !readOnly,
      })}
      onChange={onChange}
      max={10}
      min={1}
      autoFocus={!readOnly}
    />
  ),
);

export const MetaEventsTableMock = ({
  traffic,
  pageView,
  setPageView,
}: Props) => {
  const tableIconStyle = { fontSize: 16 };

  const tableData = [
    {
      label: 'Page View',
      icon: <FileOutlined style={tableIconStyle} />,
      readOnly: false,
      value: pageView,
      onChange: setPageView,
      total: traffic * 2,
    },
    {
      label: 'View Content',
      icon: <EyeOutlined style={tableIconStyle} />,
      readOnly: true,
      value: 5.1,
      total: traffic * 0.75,
    },
    {
      label: 'Initiate Checkout',
      icon: <CreditCardOutlined style={tableIconStyle} />,
      readOnly: true,
      value: 4.7,
      total: traffic * 0.35,
    },
    {
      label: 'Product Visited',
      icon: <SkinOutlined style={tableIconStyle} />,
      readOnly: true,
      value: 4.9,
      total: traffic * 0.15,
    },
    {
      label: 'Purchase',
      icon: <CreditCardOutlined style={tableIconStyle} />,
      readOnly: true,
      value: 4.1,
      total: traffic * 0.015,
    },
  ];

  return (
    <div className={classNames(styles.column, styles.table)}>
      <div className={styles.gridRow}>
        {['Events', 'Event Match Quality', 'Total Events'].map(item => (
          <span key={item} className={styles.tableLabel}>
            {item}
          </span>
        ))}
      </div>
      {tableData.map(data => (
        <div className={styles.gridRow} key={data.label}>
          <div className={classNames(styles.row, styles.gap6)}>
            {data.icon}
            <div className={styles.column}>
              <span className={styles.tableLabel}>{data.label}</span>
              <Status
                status="active"
                color="#389E0D"
                className={styles.status}
              />
            </div>
          </div>
          <div className={classNames(styles.row, styles.gap8, styles.content)}>
            <MemoizedInputNumber
              value={data.value}
              readOnly={data.readOnly}
              onChange={v => data.onChange?.(v)}
            />
            <span className={styles.tableLabel}>/10</span>
            <WarningFilled className={styles.warningIcon} />
          </div>
          <div className={styles.tableLabel}>
            {abbreviateNumber(data.total)}
          </div>
        </div>
      ))}
    </div>
  );
};
